export const APP_LINK =
    'itms-apps://apps.apple.com/us/app/solitaire-story-tripeaks-cards/id1494307145';
export const SUPPORT_EMAIL = 'support@softgames.de';
export const EMAIL_SUBJECT = 'Solitaire%20Story%20iOS%20Support';
export const APP_RATE_REMINDER_MIN_LEVEL = 9;
